export default "__VITE_ASSET__0db3c163__"